import{a as r}from"./chunk-A63SMUOU.mjs";import{b as t}from"./chunk-BCUSI3N6.mjs";var e=class extends r{toString(){let s=this.bcsToBytes();return t.fromHexInput(s).toString()}};export{e as a};
//# sourceMappingURL=chunk-MQGW234H.mjs.map